const imgHost = "/serverimg";
const uploadUrl = process.env.VUE_APP_BASE_API + "/file/uploadimage";

export default {
  imgHost,
  uploadUrl,
};
